// Per-page titles and descriptions for the document head.
//
// The HTML file still carries the homepage defaults so a crawler that never
// runs JavaScript (LinkedIn, Slack, iMessage) gets a real card. This map is
// what Googlebot and the browser tab see after React mounts: each route gets
// its own title, description and canonical URL. The share image is one
// designed card (name + line) on every page — not a screenshot of the work
// grid, which LinkedIn compresses into mush — unless a page names its own
// `image` and `imageAlt`, a card in the same style with that page's title.
//
// Titles omit "| Portfolio". The name and the role are the query; the rest
// of the title is the page. Descriptions stay near 150 characters so they
// survive Google's snippet trim.

export const SITE_URL = "https://www.oscarrabadan.com";
export const SITE_NAME = "Oscar Rabadán";
export const OG_IMAGE = `${SITE_URL}/images/ogimage.jpg`;
export const OG_IMAGE_ALT =
  "Oscar Rabadán, product designer for problems that span design, product and code.";

export const DEFAULT_SEO = {
  title: "Oscar Rabadán — Product Designer",
  description:
    "Product designer in Barcelona turning complex problems into products people use, from the first question to what ships, with systems thinking and AI.",
};

const PAGES = {
  "/": DEFAULT_SEO,
  "/work": {
    title: "Work — Oscar Rabadán",
    description:
      "Case studies, apps, Figma plugins, interface work and motion by Oscar Rabadán, product designer in Barcelona.",
  },
  "/case-study/design-system": {
    title: "The design system people and AI build every product from — Oscar Rabadán",
    description:
      "I designed one foundation of components, tokens, screen recipes and AI skills for web, iOS and Android. It became the company’s default way of building frontend.",
    image: `${SITE_URL}/images/og-design-system.jpg`,
    imageAlt:
      "Case study “The design system people and AI build every product from”, beside a diagram of one shared foundation turning a spec, a Figma frame, tokens and skills into a reviewed screen.",
  },
  "/case-study/ai-workflow": {
    title: "Designing how people and AI work together — Oscar Rabadán",
    description:
      "A shipped merchant-support workflow where AI prepared the evidence and specialists kept the decision: −72% tickets needing full manual review, then the base of an AI lifecycle.",
  },
  "/case-study/installments": {
    title: "Doubling installment revenue by finding the right moment — Oscar Rabadán",
    description:
      "A banking app had to double installment revenue in a year. We mapped the payment decision and launched a split option at authorization: +114% revenue.",
  },
  "/case-study/checkout": {
    title: "Increasing checkout conversion through systems thinking — Oscar Rabadán",
    description:
      "A hosted checkout was losing payments to trust, decision load and failed retries. I mapped the loops and turned the four strongest into controlled experiments.",
  },
  "/add-to-bag-demo": {
    title: "Add to bag animation demo — Oscar Rabadán",
    description:
      "A microinteraction built with Rive, Framer Motion and React: a product card flying into a shopping bag.",
  },
};

// Any other path renders the not-found page (retired articles included), which
// must never be indexed. /about redirects to the homepage before it renders.
export const NOT_FOUND_SEO = {
  title: "Page not found — Oscar Rabadán",
  description: "This page is not available. It may have been moved or retired.",
  noindex: true,
};

export function getPageSeo(pathname) {
  if (pathname === "/about") return DEFAULT_SEO;
  return PAGES[pathname] || NOT_FOUND_SEO;
}

export const SITEMAP_PATHS = Object.keys(PAGES);
